import { render, staticRenderFns } from "./DynamicCheckbox.vue?vue&type=template&id=043cd50e&scoped=true&"
import script from "./DynamicCheckbox.vue?vue&type=script&lang=js&"
export * from "./DynamicCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./DynamicCheckbox.vue?vue&type=style&index=0&id=043cd50e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043cd50e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
